var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"SBImageStep"},[_c('img',{attrs:{"src":_vm.image}}),_c('span',[_vm._v(_vm._s(_vm.title))]),_c('p',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }